var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('div',{staticClass:"d-flex align-items-center justify-content-center mt-5"},[_c('div',{staticClass:"spinner-border"})]):[(_vm.assistant)?_c('TrainSingle',{key:_vm.assistant.id,on:{"onBack":_vm.deselectAssistant,"updated":_vm.modelUpdated}}):_vm._e()]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }